/**
 * @param {RootState} state
 * @return {EditCreateVmState}
 */
export const ecVMSel = (state) => state.ecVmPage;
export const ecVMDatacenterSel = (state) => state.ecVmPage.name;
